import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createPolymorphicComponent, } from '../../helpers/react/polymorphicComponentTypes';
import { useStyles } from '../../hooks/useStyles';
import { textStyles } from './Text.styles';
import { Base } from '../Base';
import { commonStyles } from '../../helpers/commonStyles';
export const textTagMap = {
    display$lg: 'span',
    display$md: 'span',
    display$sm: 'span',
    headline$lg: 'h1',
    headline$md: 'h2',
    headline$sm: 'h3',
    title$lg: 'h4',
    title$md: 'h5',
    title$sm: 'h6',
    body$lg: 'p',
    body$md: 'p',
    body$sm: 'p',
    label$lg: 'span',
    label$md: 'span',
    label$sm: 'span',
};
export const Text = createPolymorphicComponent(forwardRef(function Text(props, forwardedRef) {
    const { as, styles, sx, variant = 'body', size = 'md', children, gutterBottom, dimmed, truncate, truncateLines, ...other } = props;
    const { combineStyles, globalStyles } = useStyles({
        name: 'Text',
        styles: [textStyles, styles],
    });
    const rootElement = as ?? textTagMap[`${variant}$${size}`];
    return (_jsx(Base, { as: rootElement, ...other, sx: [
            globalStyles,
            combineStyles('host', dimmed && 'host$dimmed', truncate && commonStyles.truncate, !!truncateLines &&
                truncateLines > 0 &&
                commonStyles.truncateLines(truncateLines), gutterBottom && 'host$gutterBottom', `${variant}$${size}`, sx),
        ], ref: forwardedRef, children: children }));
}));
